import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStripe } from '@stripe/react-stripe-js';
import { useMst } from '../../../models/stores/Root';
import { AddressContract } from '../../../types/Address';

// This component is coupled to WrappedStripeWalletLoader, do not use it by itself
const StripeWalletLoader: React.FC = observer(() => {
  const rootStore = useMst();
  const { cart, customer } = rootStore;
  const stripe = useStripe();

  useEffect(() => {
    const setupStripe = async () => {
      if (stripe) {
        const walletIntent = await rootStore.getIncomingWalletIntent();
        if (walletIntent) {
          rootStore.setCartForStripeWalletCheckout(walletIntent);
          let shippingAddress: AddressContract | undefined;
          if (customer.isLoggedIn) {
            try {
              shippingAddress =
                await customer.addShippingAddressToAuthenticatedCustomer(
                  walletIntent.shipping
                );
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error(error);
              shippingAddress = walletIntent.shipping;
            }
          } else {
            shippingAddress = walletIntent.shipping;
          }
          if (shippingAddress) {
            cart.updateShippingAddress(shippingAddress);

            const cartService = cart.getCartService();
            const cartResponse = await cartService.postCartDataAsync(
              cart.cartId,
              cart.cartData
            );
            cart.setShippingMethods(cartResponse.shippingMethods);
            if (walletIntent.shippingMethodId) {
              cart.updateShippingMethod(
                parseInt(walletIntent.shippingMethodId, 10)
              );
            }
          }

          let billingAddress: AddressContract | undefined;
          if (customer.isLoggedIn) {
            try {
              billingAddress =
                await customer.addBillingAddressToAuthenticatedCustomer(
                  walletIntent.billing
                );
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error(error);
              billingAddress = walletIntent.billing;
            }
          } else {
            billingAddress = walletIntent.billing;
          }
          if (billingAddress) {
            cart.updateBillingAddress(billingAddress);
          }
          if (walletIntent.customer.emailAddress) {
            await rootStore.setEmailRegistered(
              walletIntent.customer.emailAddress
            );
          }
          await cart.updateCartFlow();
          rootStore.send({ type: 'WALLET_LOADED' });
        } else {
          rootStore.send({ type: 'WALLET_ERROR' });
        }
      }
    };
    setupStripe();
  });

  return null;
});

export default StripeWalletLoader;
